export class ValidationError extends Error {
  public messages: string[];
  public detail?: string;
  public fieldErrors?: Record<string, { code: string; message: string }>;

  constructor(messages: string[]) {
    const normalizedMessages = (messages ?? [])
      .map(m => String(m ?? '').trim())
      .filter(Boolean);

    super(normalizedMessages.join('\n') || 'Erro de validação');
    this.name = 'ValidationError';
    this.messages = normalizedMessages;
  }
}
